<template>
  <v-col cols="12">
    <v-subheader class="px-0">{{ label }}</v-subheader>
    <v-slider dense class="mt-0" v-model="computedValue" v-bind="$attrs">
      <template v-slot:append>
        <v-col style="min-width: 40px" class="pa-0">{{ computedValue }}%</v-col>
      </template>
    </v-slider>
  </v-col>
</template>
<script>
export default {
  props: {
    label: {
      type: String
    },
    value: {
      type: [String, Number],
      default: 0
    }
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(nV) {
        this.$emit('input', nV);
      }
    }
  }
};
</script>